<div class="cs-sb__scroll">
  <ul class="cs-sb__list">
    @for (item of items(); track item.id) {
      @if (item.dividerBefore) {
        <li class="cs-sb__divider" aria-hidden="true"></li>
      }
      <li class="cs-sb__item">
        <button
          type="button"
          class="cs-sb__row"
          [class.cs-sb__row--active]="!item.nonRoute && isActive(item.id)"
          [disabled]="item.disabled || null"
          [attr.aria-current]="!item.nonRoute && isActive(item.id) ? 'page' : null"
          [attr.aria-expanded]="item.children?.length ? isExpanded(item.id) : null"
          (click)="onItemClick(item)"
        >
          <span
            class="cs-sb__icon"
            [innerHTML]="iconSvg(item.icon, 20, !item.nonRoute && isActive(item.id) ? 2 : 1.5)"
            aria-hidden="true"
          ></span>
          <span class="cs-sb__label">{{ item.label }}</span>
          @if (item.children?.length) {
            <span
              class="cs-sb__chevron"
              [class.cs-sb__chevron--open]="isExpanded(item.id)"
              [innerHTML]="iconSvg('chevron-down', 18)"
              aria-hidden="true"
            ></span>
          }
        </button>

        @if (item.children?.length && isExpanded(item.id)) {
          <ul class="cs-sb__sublist">
            @for (child of item.children; track child.id) {
              <li>
                <button
                  type="button"
                  class="cs-sb__row cs-sb__row--sub"
                  [class.cs-sb__row--active]="isActive(child.id)"
                  [disabled]="child.disabled || null"
                  [attr.aria-current]="isActive(child.id) ? 'page' : null"
                  (click)="onItemClick(child)"
                >
                  <span
                    class="cs-sb__icon"
                    [innerHTML]="iconSvg(child.icon, 20, isActive(child.id) ? 2 : 1.5)"
                    aria-hidden="true"
                  ></span>
                  <span class="cs-sb__label">{{ child.label }}</span>
                </button>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</div>

<div class="cs-sb__footer">
  <ul class="cs-sb__list">
    @for (item of footerItems(); track item.id) {
      <li class="cs-sb__item">
        <button
          type="button"
          class="cs-sb__row"
          [class.cs-sb__row--active]="!item.nonRoute && isActive(item.id)"
          [attr.aria-current]="!item.nonRoute && isActive(item.id) ? 'page' : null"
          [disabled]="item.disabled || null"
          (click)="onItemClick(item)"
        >
          <span
            class="cs-sb__icon"
            [innerHTML]="iconSvg(item.icon, 20, !item.nonRoute && isActive(item.id) ? 2 : 1.5)"
            aria-hidden="true"
          ></span>
          <span class="cs-sb__label">{{ item.label }}</span>
        </button>
      </li>
    }
  </ul>
</div>
